import React, { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';
import attendaSvg from "/attendasvg.svg";

interface LoaderProps {
  duration?: number;
  onComplete?: () => void;
}

const Loader: React.FC<LoaderProps> = ({ duration, onComplete }) => {
  const loaderRef = useRef<HTMLDivElement>(null);
  const imageRef = useRef<HTMLImageElement>(null);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (loaderRef.current) {
      // Create the animation timeline
      const tl = gsap.timeline({ repeat: -1 });

      // Initial state
      gsap.set(imageRef.current, { opacity: 0, scale: 0.8 });

      // Fade in and scale up animation for image
      tl.to(imageRef.current, {
        opacity: 1,
        scale: 1,
        duration: 1.5,
        ease: "power2.out"
      })
      // Hold everything visible
      .to({}, { duration: 1 })
      // Fade out and scale down animation for image
      .to(imageRef.current, {
        opacity: 0,
        scale: 0.8,
        duration: 1.5,
        ease: "power2.in"
      })
      // Hold everything invisible
      .to({}, { duration: 1 });

      // If duration is provided, set a timeout to hide the loader
      if (duration) {
        const timer = setTimeout(() => {
          setIsVisible(false);
          onComplete?.();
        }, duration);

        return () => {
          clearTimeout(timer);
          tl.kill();
        };
      }

      // Cleanup animation on unmount
      return () => {
        tl.kill();
      };
    }
  }, [duration, onComplete]);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="flex items-center justify-center" ref={loaderRef}>
        <div className="w-64 h-64 flex items-center justify-center">
          <img 
            ref={imageRef}
            src={attendaSvg} 
            alt="ATTENDA" 
            className="w-full h-full object-contain"
          />
        </div>
      </div>
    </div>
  );
};

export default Loader; 